import { Tabs, TabList, TabPanels, Tab, TabPanel, Box, Image, Text, SimpleGrid, Heading } from '@chakra-ui/react';
import TabContent from './TabContent';
import benefits from './images/benefits.png';
import stadistics from './images/stadistics.png';
import contributions from './images/contributions.png';
import indicators from './images/indicators.png';
import imageHome from './images/image_home.png';
import { Stack } from '@chakra-ui/react';

export interface Info {
  title: string;
  subtitle: string;
  description: string;
  image: string;
}

export interface ResultsInfo {
  title: string;
  results: {
    description: string;
    value: string;
  }[];
}

export interface Section {
  title: string;
  image: string;
}

const info: Info = {
  title: 'Información del programa',
  subtitle: 'Conocé los objetivos del programa y las acciones que realizamos para llevarlo acabo',
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  image: imageHome,
};

const resultsInfo: ResultsInfo = {
  title: 'Información de Resultados',
  results: [
    {
      description: 'Lorem ipsum dolo',
      value: '3000',
    },
    {
      description: 'Lorem ipsum dolo',
      value: '3000',
    },
    {
      description: 'Lorem ipsum dolo',
      value: '3000',
    },
  ],
};

const sections: Section[] = [
  { title: 'Estadísticas', image: stadistics },
  { title: 'Beneficios', image: benefits },
  { title: 'Aportaciones', image: contributions },
  { title: 'Indicadores', image: indicators },
];

const allTabs = [info, resultsInfo, ...sections];

const Impact = () => {
  return (
    <Tabs minH="80vh">
      <TabList display={{ base: 'none', md: 'flex' }} justifyContent="space-between" p={2}>
        {allTabs.map((section) => (
          <Tab
            key={section.title}
            bg="transparent"
            color="#4b5465"
            fontSize="md"
            fontWeight="medium"
            _active={{ bg: 'transparent' }}
            _focus={{ boxShadow: 'none' }}
            _selected={{ color: 'var(--primary)', bg: 'transparent' }}
          >
            {section.title}
          </Tab>
        ))}
      </TabList>

      <TabPanels>
        <TabPanel>
          {/* Primer panel: info */}
          <SimpleGrid columns={{ base: 1, lg: info.image ? 2 : 1 }} py={{ base: 1, lg: 8 }}>
            <Box p={2} display="flex" flexDirection="column" gap={5}>
              <Heading as="h3" fontSize={{ base: 'lg', md: '3xl' }} fontWeight="medium" color="#4b5465">
                {info.title}
              </Heading>
              <Heading as="h2" fontSize={{ base: '2xl', md: '4xl' }} fontWeight="medium">
                {info.subtitle}
              </Heading>
              <Text fontSize={{ base: 'md', md: 'xl' }}>{info.description}</Text>
            </Box>
            {info.image && (
              <Box display="flex" justifyContent="center" alignItems="center" overflow="hidden">
                <Image maxW="536px" src={info.image} />
              </Box>
            )}
          </SimpleGrid>

          {/* Resultados */}
          <Stack py={8}>
            <Heading as="h3" fontSize={{ base: 'lg', md: '3xl' }} fontWeight="medium" color="#4b5465">
              {resultsInfo.title}
            </Heading>
            <SimpleGrid w="100%" columns={{ base: 1, md: 3 }} spacing={4} py={10}>
              {resultsInfo.results.map((result, i) => (
                <Box
                  key={i}
                  maxW={{ base: '100%', md: '399px' }}
                  bg="white"
                  borderRadius="xl"
                  boxShadow="md"
                  textAlign="center"
                  color="var(--primary)"
                  fontWeight="semibold"
                  p={6}
                >
                  <Text fontSize="4xl">+{result.value}</Text>
                  <Text fontSize="2xl">{result.description}</Text>
                </Box>
              ))}
            </SimpleGrid>
          </Stack>

          {sections.map((section) => (
            <TabContent key={section.title} title={section.title} image={section.image} />
          ))}
        </TabPanel>
        <TabPanel>
          <SimpleGrid w="100%" columns={{ base: 1, md: 3 }} spacing={4} py={10}>
            {resultsInfo.results.map((result, i) => (
              <Box
                key={i}
                maxW={{ base: '100%', md: '399px' }}
                bg="white"
                borderRadius="xl"
                boxShadow="md"
                textAlign="center"
                color="var(--primary)"
                fontWeight="semibold"
                p={6}
              >
                <Text fontSize="4xl">+{result.value}</Text>
                <Text fontSize="2xl">{result.description}</Text>
              </Box>
            ))}
          </SimpleGrid>
        </TabPanel>
        {sections.map((section) => (
          <TabPanel key={section.title}>
            <TabContent title={section.title} image={section.image} />
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};

export default Impact;
